import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { ThemeModel } from "../models/theme.model";
import { Observable, BehaviorSubject } from "rxjs";
import { isPlatformBrowser } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  usedTheme$: BehaviorSubject<ThemeModel> = new BehaviorSubject(null);
  constructor(@Inject(PLATFORM_ID) public platformId) {}

  /* Updating the CSS theme variables  */
  updateTheme(theme: ThemeModel): void {
    if (isPlatformBrowser(this.platformId)) {
      window.document.body.style.setProperty(
        "--primary-text",
        theme.primaryText
      );
      window.document.body.style.setProperty(
        "--secondary-text",
        theme.secondaryText
      );
      window.document.body.style.setProperty("--primary-bg", theme.primaryBg);
      window.document.body.style.setProperty(
        "--secondary-bg",
        theme.secondaryBg
      );
      window.document.body.style.setProperty("--accent", theme.accent);
      window.document.body.style.setProperty("--gradient-bg", theme.gradientBg);
      window.document.body.style.setProperty(
        "--gradient-image",
        theme.gradientImage
      );
    }
  }

  getUsedTheme(): Observable<ThemeModel> {
    return this.usedTheme$.asObservable();
  }
  setUsedTheme(theme: ThemeModel): void {
    this.usedTheme$.next(theme);
  }
}
